<div class="container-fluid">
    <div class="row">
       <div class="col-md-12 p-0">
           <img src="assets/img/BSBHome.jpg" class="img-fluid w-100">
       </div>
   </div>
</div>